export default __webpack_public_path__ + "b3125d315a6ae9dd8dbc149cc5bda3ce.jpeg";